

























import { defineComponent } from '@vue/composition-api'
import { TcButton } from '@telia/shared-ui-components'
import CookieConsentModal from '@/components/cookie-consent/CookieConsentModal.vue'
import {
  updateLevelSelected,
  closeMainModal,
  openConsentModal
} from '@/store/modules/cookie-consent.store'

export default defineComponent({
  components: {
    CookieConsentModal,
    TcButton
  },
  props: {
    content: Object
  },
  setup (props, context) {
    const store = context.root.$store

    const acceptCookies = () => {
      updateLevelSelected(store, 3)
      closeMainModal(store)
    }

    const onOpenConsentModal = () => {
      openConsentModal(store)}

    return {
      acceptCookies,
      onOpenConsentModal
    }
  }
})
